import type { VideoShow } from '@ori/graphql-schema';

import { LiveStreamingStates } from '../models';
import { ShowType } from '../models/graphql-types/graphql';

const RecentShowMaxAgeInHours = 24;
export interface VideoShoppingConfiguration {
  isVideoShoppingEnabled: boolean | null | undefined;
  currentVideoShow?: VideoShow | null;
}
const subtractHoursToDate = (date: Date, hours: number): Date =>
  new Date(new Date(date).setHours(date.getHours() - hours));

export const getLiveStreamingStateByVideoConfig = ({
  isVideoShoppingEnabled,
  currentVideoShow,
}: VideoShoppingConfiguration): LiveStreamingStates => {
  const { endedAtUtc, typeOfShow } = currentVideoShow ?? {};

  if (isVideoShoppingEnabled) {
    switch (typeOfShow) {
      case ShowType.Live:
        return LiveStreamingStates.IS_LIVE;
      case ShowType.Scheduled:
        return LiveStreamingStates.PLANNED;
      case ShowType.Ended: {
        if (endedAtUtc) {
          const endedAtUtcDate = new Date(endedAtUtc);

          return subtractHoursToDate(new Date(), RecentShowMaxAgeInHours) <= endedAtUtcDate
            ? LiveStreamingStates.WAS_LIVE
            : LiveStreamingStates.UNKNOWN;
        }
        break;
      }
      /* istanbul ignore next - not reachable */
      default:
        return LiveStreamingStates.UNKNOWN;
    }
  }

  return LiveStreamingStates.UNKNOWN;
};
